import React from "react";
import Chart from "react-apexcharts";

const DonutChart = ({ pieChart }) => {
  const activeUsers = pieChart?.total_user ?? 0;
  const androidUsers = pieChart?.android_user ?? 0;
  const iosUsers = pieChart?.ios_user ?? 0;

  const options = {
    chart: {
      type: "donut",
    },
    labels: ["Total", "Android Users", "iOS Users"],
    legend: {
      position: "bottom",
    },
    colors: ["#00E396", "#008FFB", "#FEB019"],
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " users";
        },
      },
    },
  };

  const series = [activeUsers, androidUsers, iosUsers];

  return (
    <div style={{ height: "415px" }}>
      <Chart
        options={options}
        series={series}
        type="donut"
        width="100%"
        height={350}
      />
    </div>
  );
};

export default DonutChart;
